import {IRegisterUserBody} from "../../../../store/auth/Helper";


export const initialRegisterBody: IRegisterUserBody = {
    email: "",
    full_name: "",
    name: "",
    surname: "",
    password: "",
    phone_number: undefined,
    subscribed: false
}
